require('../../modules/es6.number.epsilon');
module.exports = Math.pow(2, -52);



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/number/epsilon.js
// module id = 411
// module chunks = 0 1